<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.81748 11.4255C4.40564 11.0099 4.3928 10.3226 4.78879 9.89036L11.2543 2.8332C11.4493 2.62031 11.7186 2.5 12 2.5C12.2814 2.5 12.5507 2.62031 12.7457 2.8332L19.2112 9.89036C19.6072 10.3226 19.5944 11.0099 19.1825 11.4255C18.7707 11.8411 18.1158 11.8276 17.7198 11.3954L13.0345 6.2813L13.0345 20.4143C13.0345 21.0139 12.5713 21.5 12 21.5C11.4287 21.5 10.9655 21.0139 10.9655 20.4143L10.9655 6.2813L6.28018 11.3954C5.88418 11.8276 5.22931 11.8411 4.81748 11.4255Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'OrderUp' };
</script>
